import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChartDataset, ChartOptions } from 'chart.js';
import { GoogleChartInterface } from 'ng2-google-charts';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {



  constructor(private http: HttpClient) {
    this.geoChartData = [
      ['Country', 'Popularity'],
      ['Germany', 200],
      ['United States', 300],
      ['Brazil', 400],
      ['Canada', 500],
      ['France', 550],
      ['RU', 350],
      ['India', 700]
    ];
  }
  states_data = [['State', 'COVID-Confirmed Cases']];
  response: any[] = [];
  mapReady = true;
  mydataset: any = [];

  public lineChartData: ChartDataset[] = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
  ];
  public lineChartLabels: any[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions: any = {
    responsive: true,
  };
  public lineChartColors: any[] = [
    {
      borderColor: '#DD4036',
      backgroundColor: '#ffffff00',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];
  geoChartData: any;

   public geoChart: GoogleChartInterface = {
    chartType: 'GeoChart',
    dataTable: this.states_data,
    options: {
      region: 'IN', // INDIA
      colorAxis: { colors: ['#DD4036', '#DD4036', '#ff7461', '#ff7461', '#DD4036'] },
      resolution: 'provinces',
      backgroundColor: '#00000',
      datalessRegionColor: '#00000',
      defaultColor: '#00000',
      height: 300,
    }
  };

  ngOnInit(): void {
//     this.mydataset = [['Maharashtra',10],
// ['Karnataka',20],
// ['Punjab',30],
// ['Gujarat',40]]
    this.getData().subscribe((res) => {
      this.response = res.statewise;
      this.response.splice(0, 1);

      for (const state of this.response) {
        let temp = [state.state, Number(state.confirmed)];
        if (state.state == 'Punjab') {
          temp = ['IN-OR', Number(state.confirmed)];
        }
        this.states_data.push(temp);
      }
      this.mapReady = true;
    },
      (err) => {
        console.log(err);
      }
    );
  }


  getData(): Observable<any> {
    return this.http.get<any>('https://api.covid19india.org/data.json');
  }

}




